import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class DesignInTrashCanService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiUserURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listDesignsInTrashCan = ({ page, userId }) => {
    const request = {
      method: 'GET',
      url: '/designs/delete',
      params: {
        page,
        max_results: 20,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  deletePermanetlyDesignInTrashCan = (id, userId) => {
    const request = {
      method: 'POST',
      url: '/designs/delete',
      data: {
        id,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  restoreDesignInTrashCan = (id) => {
    const request = {
      method: 'POST',
      url: '/designs/delete/restore',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  listAssetsInTrashCan = ({ page, userId }) => {
    const request = {
      method: 'GET',
      url: '/assets/delete',
      params: {
        page,
        max_results: 20,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  deletePermanetlyAssetsInTrashCan = (id) => {
    const request = {
      method: 'POST',
      url: '/assets/delete',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  restoreAssetsInTrashCan = (id) => {
    const request = {
      method: 'POST',
      url: '/assets/delete/restore',
      data: {
        id,
      },
    };
    return this.axios(request);
  };
}

export default new DesignInTrashCanService();
